
import { useState } from 'react';

export default function ManufacturersProducts() {
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [selectedManufacturer, setSelectedManufacturer] = useState<string | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleInquirySubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3c8ocsef3sotc9j5t8h', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。');
        form.reset();
        setShowInquiryForm(false);
      }
    } catch (error) {
      alert('送信に失敗しました。お電話でのお問い合わせもお受けしております。');
    }
  };

  const manufacturers = [
    {
      id: 'okura',
      name: 'オークラ輸送機株式会社',
      established: '1953年',
      specialty: '高床式パレタイザー・コンベヤシステム',
      description: '物流機器の総合メーカーとして、豊富な実績を持つリーディングカンパニー',
      image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20facility%20of%20major%20conveyor%20and%20palletizer%20manufacturer%2C%20corporate%20headquarters%20building%2C%20professional%20manufacturing%20company&width=400&height=300&seq=okura-facility&orientation=landscape',
      products: [
        {
          name: '高床式パレタイザ PHC100S',
          type: '機械式',
          capacity: '800-1200ケース/時',
          features: ['高速処理', '安定積み付け', '省メンテナンス'],
          applications: ['飲料業界', '食品大量生産', '化学工業'],
          price: '2,500万円〜',
          image: 'https://readdy.ai/api/search-image?query=High-level%20mechanical%20palletizer%20PHC100S%20in%20beverage%20factory%2C%20large%20industrial%20equipment%20with%20conveyor%20system%2C%20automated%20stacking%20machinery&width=300&height=200&seq=phc100s&orientation=landscape'
        }
      ],
      strengths: [
        '60年以上の実績',
        '総合物流システム',
        '充実したアフターサービス',
        '豊富な業界対応実績'
      ],
      marketShare: '国内シェア30%',
      supportArea: '全国対応'
    },
    {
      id: 'fuji',
      name: '不二輸送機工業株式会社',
      established: '1944年',
      specialty: '多関節ロボットパレタイザー',
      description: 'ロボット技術に特化した自動化ソリューションプロバイダー',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20robotics%20manufacturing%20facility%2C%20modern%20industrial%20automation%20company%20building%2C%20high-tech%20production%20environment&width=400&height=300&seq=fuji-facility&orientation=landscape',
      products: [
        {
          name: 'パレタイザ EC201',
          type: '多関節ロボット',
          capacity: '400-600ケース/時',
          features: ['多品種対応', '6パレット同時', '柔軟性高'],
          applications: ['多品種製造', '物流センター', '自動車部品'],
          price: '2,000万円〜',
          image: 'https://readdy.ai/api/search-image?query=Multi-axis%20articulated%20robot%20palletizer%20EC201%20handling%20various%20products%2C%20flexible%20automation%20system%20in%20modern%20warehouse&width=300&height=200&seq=ec201&orientation=landscape'
        }
      ],
      strengths: [
        'ロボット技術の先駆者',
        '多品種対応力',
        'カスタマイズ対応',
        '技術サポート充実'
      ],
      marketShare: '国内シェア25%',
      supportArea: '全国対応'
    },
    {
      id: 'star',
      name: '株式会社スター精機',
      established: '1962年',
      specialty: '直交ロボットパレタイザー',
      description: 'プラスチック成形機で培った技術を活かした精密自動化機器メーカー',
      image: 'https://readdy.ai/api/search-image?query=Precision%20manufacturing%20company%20facility%2C%20industrial%20automation%20equipment%20manufacturer%2C%20modern%20factory%20building&width=400&height=300&seq=star-facility&orientation=landscape',
      products: [
        {
          name: 'ロボットパレタイザー PXT-1220',
          type: '直交ロボット',
          capacity: '200-400ケース/時',
          features: ['省スペース', 'コンパクト設計', '操作简単'],
          applications: ['軽量物製造', '中小企業', '食品加工'],
          price: '1,500万円〜',
          image: 'https://readdy.ai/api/search-image?query=Compact%20cartesian%20robot%20palletizer%20PXT-1220%20in%20small%20manufacturing%20facility%2C%20space-saving%20automation%20equipment&width=300&height=200&seq=pxt1220&orientation=landscape'
        }
      ],
      strengths: [
        '精密技術力',
        'コンパクト設計',
        'コストパフォーマンス',
        '中小企業サポート'
      ],
      marketShare: '国内シェア15%',
      supportArea: '関東・関西中心'
    },
    {
      id: 'yushin',
      name: '株式会社ユーシン精機',
      established: '1973年',
      specialty: 'パレタイジングロボット',
      description: '射出成形機周辺機器で培った自動化技術を活用したロボットメーカー',
      image: 'https://readdy.ai/api/search-image?query=High-tech%20robotics%20manufacturing%20facility%2C%20automated%20equipment%20production%20company%2C%20modern%20industrial%20complex&width=400&height=300&seq=yushin-facility&orientation=landscape',
      products: [
        {
          name: 'パレタイジングロボット PAシリーズ',
          type: '直交ロボット',
          capacity: '300-500ケース/時',
          features: ['高精度', '多軸制御', '省エネ設計'],
          applications: ['精密部品', '電子機器', '医薬品'],
          price: '1,800万円〜',
          image: 'https://readdy.ai/api/search-image?query=Precision%20palletizing%20robot%20PA%20series%20handling%20electronic%20components%2C%20high-accuracy%20automation%20system&width=300&height=200&seq=pa-series&orientation=landscape'
        }
      ],
      strengths: [
        '高精度技術',
        '省エネ設計',
        'IoT対応',
        '予防保全システム'
      ],
      marketShare: '国内シェア12%',
      supportArea: '全国対応'
    },
    {
      id: 'additional',
      name: 'その他メーカー',
      established: '各社様々',
      specialty: '特殊用途・カスタム対応',
      description: '特定業界や特殊要求に対応する専門メーカー群',
      image: 'https://readdy.ai/api/search-image?query=Various%20industrial%20automation%20equipment%20from%20different%20manufacturers%2C%20diverse%20palletizing%20solutions%2C%20specialized%20industrial%20machinery&width=400&height=300&seq=other-manufacturers&orientation=landscape',
      products: [
        {
          name: 'ロボットパレタイザ AI1800',
          type: '多関節ロボット',
          capacity: '500-800ケース/時',
          features: ['AI制御', '学習機能', '最適化自動'],
          applications: ['先進製造業', 'スマートファクトリー', 'AI活用'],
          price: '2,800万円〜',
          image: 'https://readdy.ai/api/search-image?query=AI-powered%20robotic%20palletizer%20AI1800%20with%20smart%20control%20system%2C%20advanced%20automation%20with%20machine%20learning&width=300&height=200&seq=ai1800&orientation=landscape'
        }
      ],
      strengths: [
        '特殊要求対応',
        '最新技術導入',
        'カスタム設計',
        'ニッチ分野強み'
      ],
      marketShare: '国内シェア18%',
      supportArea: '地域密着・専門対応'
    }
  ];

  const comparisonTable = [
    {
      criteria: '処理能力',
      okura: '800-1200ケース/時',
      fuji: '400-600ケース/時', 
      star: '200-400ケース/時',
      yushin: '300-500ケース/時',
      others: '500-800ケース/時'
    },
    {
      criteria: '得意分野',
      okura: '飲料・大量生産',
      fuji: '多品種・物流',
      star: '軽量物・中小企業',
      yushin: '精密・電子機器',
      others: 'AI・特殊用途'
    },
    {
      criteria: '価格帯',
      okura: '2,500万円〜',
      fuji: '2,000万円〜',
      star: '1,500万円〜',
      yushin: '1,800万円〜',
      others: '2,800万円〜'
    },
    {
      criteria: '設置面積',
      okura: '100㎡以上',
      fuji: '50-80㎡',
      star: '30-50㎡',
      yushin: '40-60㎡',
      others: '60-100㎡'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-800 text-white py-4 px-6">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <a href="/" className="text-2xl font-bold hover:text-orange-400 cursor-pointer transition-colors" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</a>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
            <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
            <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
            <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
            <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
            <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
            <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
          </nav>

          <div className="flex items-center space-x-6">
            <button 
              onClick={() => setShowInquiryForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              見積依頼・お問い合わせ
            </button>
            
            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white cursor-pointer"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-slate-700">
            <nav className="flex flex-col space-y-4 mt-4">
              <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
              <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
              <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
              <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
              <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
              <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
              <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
              <button 
                onClick={() => {
                  setShowInquiryForm(true);
                  setMobileMenuOpen(false);
                }}
                className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors text-left"
              >
                見積依頼・お問い合わせ
              </button>
            </nav>
          </div>
        )}
      </header>

      {/* Breadcrumb */}
      <div className="bg-slate-50 py-4 px-6">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center space-x-2 text-sm text-slate-600">
            <a href="/" className="hover:text-blue-600 cursor-pointer">ホーム</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-slate-800 font-semibold">メーカー・製品紹介</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-emerald-600 to-emerald-800 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6">主要メーカー・製品紹介</h1>
          <p className="text-xl text-emerald-100 mb-8">信頼のパレタイザーメーカーと代表製品</p>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-4xl font-bold text-slate-800 mb-6">国内パレタイザー市場</h2>
              <p className="text-lg text-slate-600 mb-6">
                日本のパレタイザー市場は、主要5社で約80%のシェアを占めています。
                各社が得意分野を持ち、業界特性に応じた最適なソリューションを提供しています。
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-blue-600 rounded mr-3"></div>
                  <span className="text-slate-700">オークラ輸送機: 30% (総合力・実績)</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-green-600 rounded mr-3"></div>
                  <span className="text-slate-700">不二輸送機工業: 25% (ロボット技術)</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-purple-600 rounded mr-3"></div>
                  <span className="text-slate-700">その他: 18% (特殊・カスタム)</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-red-600 rounded mr-3"></div>
                  <span className="text-slate-700">スター精機: 15% (コンパクト・低コスト)</span>
                </div>
                <div className="flex items-center">
                  <div className="w-4 h-4 bg-yellow-600 rounded mr-3"></div>
                  <span className="text-slate-700">ユーシン精機: 12% (精密・IoT)</span>
                </div>
              </div>
            </div>
            <div className="bg-slate-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">市場トレンド</h3>
              <div className="space-y-4">
                {[
                  { trend: 'IoT・AI技術の導入', growth: '+25%' },
                  { trend: '協働ロボット需要', growth: '+40%' },
                  { trend: '省スペース化', growth: '+20%' },
                  { trend: 'エネルギー効率', growth: '+15%' }
                ].map((item, index) => (
                  <div key={index} className="flex justify-between items-center p-3 bg-white rounded-lg">
                    <span className="font-semibold text-slate-800">{item.trend}</span>
                    <span className="text-emerald-600 font-bold">{item.growth}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Manufacturers Detail */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">主要メーカー詳細</h2>
          
          {/* Manufacturer Navigation */}
          <div className="flex justify-center mb-12">
            <div className="flex flex-wrap gap-4">
              {manufacturers.map((manufacturer, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedManufacturer(selectedManufacturer === manufacturer.id ? null : manufacturer.id)}
                  className={`px-6 py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors ${
                    selectedManufacturer === manufacturer.id 
                      ? 'bg-emerald-600 text-white' 
                      : 'bg-white text-emerald-600 border-2 border-emerald-600 hover:bg-emerald-50'
                  }`}
                >
                  {manufacturer.name.split('株式会社')[0]}
                </button>
              ))}
            </div>
          </div>

          {/* Manufacturer Details */}
          {manufacturers.map((manufacturer, manufacturerIndex) => (
            <div 
              key={manufacturerIndex} 
              className={`${selectedManufacturer && selectedManufacturer !== manufacturer.id ? 'hidden' : ''} mb-16`}
            >
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="grid lg:grid-cols-2 gap-8">
                  <div>
                    <img 
                      src={manufacturer.image}
                      alt={manufacturer.name}
                      className="w-full h-80 object-cover"
                    />
                  </div>
                  <div className="p-8">
                    <h3 className="text-3xl font-bold text-slate-800 mb-4">{manufacturer.name}</h3>
                    <p className="text-lg text-slate-600 mb-6">{manufacturer.description}</p>
                    
                    <div className="grid md:grid-cols-2 gap-6 mb-6">
                      <div>
                        <h4 className="font-bold text-slate-800 mb-2">会社情報</h4>
                        <div className="space-y-2">
                          <div className="flex justify-between">
                            <span className="text-slate-600">設立:</span>
                            <span className="font-semibold">{manufacturer.established}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-slate-600">シェア:</span>
                            <span className="font-semibold">{manufacturer.marketShare}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-slate-600">対応地域:</span>
                            <span className="font-semibold">{manufacturer.supportArea}</span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h4 className="font-bold text-slate-800 mb-2">特長・強み</h4>
                        <ul className="space-y-1">
                          {manufacturer.strengths.map((strength, idx) => (
                            <li key={idx} className="flex items-start">
                              <i className="ri-star-line text-emerald-600 mr-2 mt-1"></i>
                              <span className="text-sm text-slate-600">{strength}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="bg-emerald-50 p-4 rounded-lg">
                      <h4 className="font-bold text-emerald-800 mb-2">専門分野</h4>
                      <p className="text-emerald-700">{manufacturer.specialty}</p>
                    </div>
                  </div>
                </div>

                {/* Products */}
                <div className="p-8 border-t border-slate-200">
                  <h4 className="text-2xl font-bold text-slate-800 mb-6">代表製品</h4>
                  <div className="grid lg:grid-cols-3 gap-8">
                    {manufacturer.products.map((product, productIndex) => (
                      <div key={productIndex} className="bg-slate-50 rounded-lg overflow-hidden">
                        <img 
                          src={product.image}
                          alt={product.name}
                          className="w-full h-48 object-cover"
                        />
                        <div className="p-6">
                          <h5 className="text-xl font-bold text-slate-800 mb-2">{product.name}</h5>
                          <div className="flex items-center mb-4">
                            <span className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm font-semibold mr-2">
                              {product.type}
                            </span>
                            <span className="text-slate-600 text-sm">{product.capacity}</span>
                          </div>
                          
                          <div className="mb-4">
                            <h6 className="font-semibold text-slate-800 mb-2">主な特徴</h6>
                            <div className="flex flex-wrap gap-2">
                              {product.features.map((feature, featureIndex) => (
                                <span key={featureIndex} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                  {feature}
                                </span>
                              ))}
                            </div>
                          </div>

                          <div className="mb-4">
                            <h6 className="font-semibold text-slate-800 mb-2">適用業界</h6>
                            <div className="text-sm text-slate-600">
                              {product.applications.join('、')}
                            </div>
                          </div>

                          <div className="text-center">
                            <span className="text-2xl font-bold text-emerald-600">{product.price}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">メーカー比較表</h2>
          
          {/* Desktop Table */}
          <div className="hidden lg:block overflow-x-auto">
            <table className="w-full bg-white shadow-lg rounded-lg overflow-hidden">
              <thead className="bg-slate-800 text-white">
                <tr>
                  <th className="p-4 text-left">比較項目</th>
                  <th className="p-4 text-center">オークラ輸送機</th>
                  <th className="p-4 text-center">不二輸送機工業</th>
                  <th className="p-4 text-center">スター精機</th>
                  <th className="p-4 text-center">ユーシン精機</th>
                  <th className="p-4 text-center">その他</th>
                </tr>
              </thead>
              <tbody>
                {comparisonTable.map((row, index) => (
                  <tr key={index} className="border-b">
                    <td className="p-4 font-semibold bg-slate-50">{row.criteria}</td>
                    <td className="p-4 text-center">{row.okura}</td>
                    <td className="p-4 text-center">{row.fuji}</td>
                    <td className="p-4 text-center">{row.star}</td>
                    <td className="p-4 text-center">{row.yushin}</td>
                    <td className="p-4 text-center">{row.others}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="lg:hidden space-y-6">
            {manufacturers.slice(0, 4).map((manufacturer, index) => (
              <div key={index} className="bg-white border border-slate-200 rounded-lg shadow-lg p-6">
                <h3 className="text-xl font-bold text-slate-800 mb-4">
                  {manufacturer.name.split('株式会社')[0]}
                </h3>
                <div className="space-y-2">
                  {comparisonTable.map((row, rowIndex) => (
                    <div key={rowIndex} className="flex justify-between">
                      <span className="font-semibold">{row.criteria}:</span>
                      <span className="text-slate-600">
                        {index === 0 ? row.okura : 
                         index === 1 ? row.fuji : 
                         index === 2 ? row.star : row.yushin}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Selection Guide */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">用途別メーカー選定ガイド</h2>
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                use_case: '大量生産・飲料業界',
                recommended: 'オークラ輸送機',
                reason: '高処理能力と豊富な業界実績',
                suitable: ['2000ケース/日以上', '24時間稼働', '安定性重視'],
                image: 'https://readdy.ai/api/search-image?query=High-volume%20beverage%20production%20line%20with%20palletizer%2C%20large-scale%20industrial%20operation%2C%20continuous%2024%2F7%20production&width=300&height=200&seq=high-volume&orientation=landscape'
              },
              {
                use_case: '多品種・物流センター',
                recommended: '不二輸送機工業',
                reason: '柔軟性と多品種対応力',
                suitable: ['10品種以上', '頻繁な切り替え', 'ロボット技術'],
                image: 'https://readdy.ai/api/search-image?query=Multi-product%20logistics%20center%20with%20flexible%20palletizing%20robot%2C%20various%20package%20types%2C%20efficient%20sorting%20system&width=300&height=200&seq=multi-product&orientation=landscape'
              },
              {
                use_case: '中小企業・コスト重視',
                recommended: 'スター精機',
                reason: '省スペース・低価格',
                suitable: ['限られた予算', '小スペース', 'シンプル運用'],
                image: 'https://readdy.ai/api/search-image?query=Compact%20palletizer%20in%20small%20manufacturing%20facility%2C%20cost-effective%20automation%20solution%2C%20space-saving%20equipment&width=300&height=200&seq=cost-effective&orientation=landscape'
              }
            ].map((guide, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src={guide.image}
                  alt={guide.use_case}
                  className="w-full h-48 object-cover"
                />
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-slate-800 mb-4">{guide.use_case}</h3>
                  <div className="bg-emerald-50 p-4 rounded-lg mb-6">
                    <h4 className="font-bold text-emerald-800 mb-2">推奨メーカー</h4>
                    <p className="text-emerald-700 font-semibold">{guide.recommended}</p>
                    <p className="text-emerald-600 text-sm mt-2">{guide.reason}</p>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-800 mb-3">適用条件</h4>
                    <ul className="space-y-2">
                      {guide.suitable.map((condition, conditionIndex) => (
                        <li key={conditionIndex} className="flex items-start">
                          <i className="ri-check-line text-emerald-600 mr-2 mt-1"></i>
                          <span className="text-slate-600">{condition}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-emerald-600 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8">最適なメーカー選定をサポート</h2>
          <p className="text-xl mb-8">豊富な実績を基に、お客様に最適なメーカー・製品をご提案いたします</p>
          <div className="flex justify-center space-x-6">
            <a 
              href="/selection-guide"
              className="bg-white text-emerald-600 hover:bg-slate-100 px-10 py-4 rounded-lg text-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              機種選定ガイド
            </a>
            <button 
              onClick={() => setShowInquiryForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-10 py-4 rounded-lg text-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              メーカー相談をする
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</h3>
              <p className="text-slate-300 mb-4">パレタイザー専門企業として、製造業・物流業の自動化をサポートします。</p>
              <div className="flex space-x-4">
                <i className="ri-phone-line text-orange-400"></i>
                <span>03-1234-5678</span>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">サービス</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">機械式パレタイザー</a></li>
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">多関節ロボット</a></li>
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">直交ロボット</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">保守・メンテナンス</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">詳細情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/palletizer-basics" className="hover:text-orange-400 cursor-pointer">パレタイザーとは</a></li>
                <li><a href="/decision-criteria" className="hover:text-orange-400 cursor-pointer">導入判断基準</a></li>
                <li><a href="/case-studies" className="hover:text-orange-400 cursor-pointer">導入事例</a></li>
                <li><a href="/manufacturers-products" className="hover:text-orange-400 cursor-pointer">メーカー・製品</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">周辺機器・システム</a></li>
                <li><a href="/alternatives-comparison" className="hover:text-orange-400 cursor-pointer">代替案・比較</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">会社情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li>〒174-0000 東京都板橋区</li>
                <li>設立：1985年</li>
                <li>従業員数：120名</li>
                <li>ISO9001認証取得</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400">
            <p>&copy; 2024 パレタイザーナビ. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="text-orange-400 hover:text-orange-300 ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>

      {/* Inquiry Form Modal */}
      {showInquiryForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-slate-800">メーカー・製品のお問い合わせ</h3>
                <button 
                  onClick={() => setShowInquiryForm(false)}
                  className="text-slate-500 hover:text-slate-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="manufacturers-products-form" data-readdy-form onSubmit={handleInquirySubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">会社名 *</label>
                    <input 
                      type="text" 
                      name="company" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">お名前 *</label>
                    <input 
                      type="text" 
                      name="name" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">電話番号 *</label>
                    <input 
                      type="tel" 
                      name="phone" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">メールアドレス *</label>
                    <input 
                      type="email" 
                      name="email" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">興味のあるメーカー</label>
                  <div className="grid md:grid-cols-2 gap-2">
                    {['オークラ輸送機', '不二輸送機工業', 'スター精機', 'ユーシン精機', 'その他メーカー', '未定・相談したい'].map((manufacturer, index) => (
                      <label key={index} className="flex items-center">
                        <input type="checkbox" name="interested_manufacturers" value={manufacturer} className="mr-2" />
                        {manufacturer}
                      </label>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">導入予定・検討状況</label>
                  <select name="implementation_status" className="w-full p-3 pr-8 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500">
                    <option value="">選択してください</option>
                    <option value="情報収集段階">情報収集段階</option>
                    <option value="予算検討中">予算検討中</option>
                    <option value="具体的検討中">具体的検討中</option>
                    <option value="導入決定済み">導入決定済み</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">詳細・ご質問</label>
                  <textarea 
                    name="inquiry_details" 
                    rows={4} 
                    maxLength={500}
                    className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    placeholder="製品詳細や仕様についてお聞かせください（500文字以内）"
                  ></textarea>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
